import { Add, ExpandMore } from '@mui/icons-material';
import { Button, ButtonProps, Link, Menu, MenuItem, Typography } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { FeatureFlagsType, getFeatureFlag } from '../../../config/launch-darkly/FeatureFlagsController';
import { PATHS } from '../../../routing/routes';

export const NewProfileButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const showFuzzerProfileButton = !getFeatureFlag<boolean>(FeatureFlagsType.DEPRECATE_FUZZER_PROFILES);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const mainButtonProps: ButtonProps = showFuzzerProfileButton
    ? { onClick: handleOpen, endIcon: <ExpandMore /> }
    : { href: PATHS.PROFILES_CREATE, endIcon: <Add /> };

  return (
    <>
      <Button variant="contained" {...mainButtonProps}>
        {t('addNewProfile')}
      </Button>
      {showFuzzerProfileButton && (
        <Menu slotProps={{ paper: { sx: { minWidth: '11rem' } } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem component={Link} href={`${PATHS.PROFILES_CREATE}?profile_type=tracer`}>
            <Typography>{t('tracer')}</Typography>
          </MenuItem>
          <MenuItem component={Link} href={`${PATHS.PROFILES_CREATE}?profile_type=fuzzer`}>
            <Typography>{t('fuzzer')}</Typography>
          </MenuItem>
        </Menu>
      )}
    </>
  );
};
